export default "__VITE_ASSET__DKhN4x36__"